import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../api/client';
import { formatMoney, formatDate } from '../utils/format';
import Pagination from '../components/Pagination';
import PageHeader from '../components/PageHeader';

export default function Bids() {
  const [rows, setRows] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(true);
  const pageSize = 20;

  useEffect(() => {
    setLoading(true);
    api.get('/bids', { params: { search: search || undefined, page, pageSize } })
      .then((res) => {
        setRows(res.data.data);
        setTotal(res.data.total);
      })
      .finally(() => setLoading(false));
  }, [search, page]);

  return (
    <div>
      <PageHeader title="Bids" subtitle="Every bid placed across all auctions." />

      <div className="toolbar">
        <input
          className="search-input"
          placeholder="Search by auction title or bidder…"
          value={search}
          onChange={(e) => { setSearch(e.target.value); setPage(1); }}
        />
      </div>

      <div className="panel">
        <table className="data-table">
          <thead>
            <tr>
              <th>Auction</th><th>Bidder</th><th>Bid Amount</th>
              <th>Deposit</th><th>Active</th><th>Winning</th><th>Placed</th>
            </tr>
          </thead>
          <tbody>
            {loading && <tr><td colSpan="7" className="empty-cell">Loading…</td></tr>}
            {!loading && rows.length === 0 && (
              <tr><td colSpan="7" className="empty-cell">No bids found</td></tr>
            )}
            {!loading && rows.map((b) => (
              <tr key={b.id}>
                <td><Link to={`/auctions/${b.auction_id}`}>{b.auction_title}</Link></td>
                <td>{b.username}</td>
                <td>{formatMoney(b.bid_amount)}</td>
                <td>{b.deposit_paid ? formatMoney(b.deposit_amount) : 'Unpaid'}</td>
                <td>{b.is_active ? 'Yes' : 'No'}</td>
                <td>{b.is_winning ? 'Yes' : 'No'}</td>
                <td>{formatDate(b.created_at)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <Pagination page={page} pageSize={pageSize} total={total} onChange={setPage} />
    </div>
  );
}
